import { IconButton, Popover, Status } from '@nexelem/components';
import { useProductionPlanQueryParams, PlanView } from '../../hooks';
import { useDateFormatter } from '@nexelem/utils';
import { useCustomTranslation } from '../../../../../hooks';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faSync } from '@fortawesome/pro-light-svg-icons';
import { ProLightCircleQuestion } from '@nexelem/icons/ProLightCircleQuestion';
import { useGetSimulationStatus } from '../hooks';

export const SimulationInProgressBanner = () => {
  const { tWrapper } = useCustomTranslation('products.simulationPlan');
  const { queryParams } = useProductionPlanQueryParams();
  const isBannerVisible = queryParams.view === PlanView.GANTT;
  const { data, status } = useGetSimulationStatus({ enabled: isBannerVisible });
  const timeFormatter = useDateFormatter({ onlyHours: true });
  const dateFormatter = useDateFormatter({ displayWithHours: false });

  if (!isBannerVisible || !data) {
    return null;
  }

  const translationData = {
    id: data.simulationId,
    time: timeFormatter(data.applyingStartDate),
    date: dateFormatter(data.applyingStartDate),
  };

  if (status === 'IN_PROGRESS') {
    return (
      <>
        <Status
          color="orange"
          Icon={<FontAwesomeIcon icon={faSync} />}
          text={tWrapper('simulationInProgressBanner', translationData)}
          variant="contained"
        />
        <Popover.Root>
          <Popover.Trigger>
            <IconButton Icon={ProLightCircleQuestion} size="small" />
          </Popover.Trigger>
          <Popover.Content>{tWrapper('simulationInProgressBannerContent', translationData)}</Popover.Content>
        </Popover.Root>
      </>
    );
  }

  if (status === 'ERROR') {
    return (
      <>
        <Status color="red" text={tWrapper('simulationErrorBanner', translationData)} variant="contained" />
        <Popover.Root>
          <Popover.Trigger>
            <IconButton Icon={ProLightCircleQuestion} size="small" />
          </Popover.Trigger>
          <Popover.Content>
            <div>
              <div>{tWrapper('simulationErrorBannerContent', translationData)}</div>
              {data.applyingError && <div>{data.applyingError}</div>}
            </div>
          </Popover.Content>
        </Popover.Root>
      </>
    );
  }

  return null;
};
